import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight} from "@fortawesome/free-solid-svg-icons";
import INFO from "../../data/user";

import "./styles/projectList.css";

const ProjectsList = () => {
	return (
		<div className="projects-list">
			{INFO.projects.map((project, index) => (
				<div className="project" key={index}>
						<div className="project-logo">
							{project.logo.map((logo, index) => (
								<div className="project-logo-box" key={index}>
									<img className="project-logo-img" src={logo} alt={logo} />
								</div>
							))}
						</div>
						<div className="project-title">{project.title}</div>
						<div className="project-description">
						{project.descriptions.length > 0 && (
							<div className="project-description-item">
							{project.descriptions[0]}
							{project.descriptions.length > 1 && '...'}
							</div>
						)}
						</div>
						{project.link && <a className="project-link" href={project.link} target="_blank" rel="noreferrer">
							
							<div className="project-link-text" >
							{project.linkText}
							</div>
							<div className="project-link-icon">
								<FontAwesomeIcon icon={faArrowRight} />
							</div>
						</a>}
						
				</div>
			))}
		</div>
	);
};

export default ProjectsList;
